import React from 'react';
import {useSwiper} from "swiper/react";

const Panel = ({test, activeSlide, answers = {},setSlideNumber,slideNumber,isPassed,rightObj}) => {
    const swiper = useSwiper()
    const styles = {
        right: {
            borderColor: 'rgba(17,197,59,0.76)',
            backgroundColor: 'rgba(17,197,59,0.76)',
        },
        wrong: {
            borderColor: 'rgba(252,24,24,0.78)',
            backgroundColor: 'rgba(252,24,24,0.78)',
        },
        halfOrChecking: {
            borderColor: 'rgba(255,136,0,0.79)',
            backgroundColor: 'rgba(255,136,0,0.79)',
        },
    }

    const handlerOnClickQuestion=(questionIndex,taskIndex,e)=> {
        e.stopPropagation()
        swiper.slideTo(taskIndex)
        setSlideNumber(questionIndex)
    }
    const handlerOnClick=(index)=> {
        swiper.slideTo(index)
        setSlideNumber(1)
    }
    const blockTest = test?.tasks?.map((task, i) => {
        const taskQuestions = task?.questions?.map((item, k) => {
            const answerKey = answers[task.id]?.[item?.number];
            const hasAnswer = !!(answerKey && Object.keys(answerKey).length);
            const questionNumber = k + 1;
            const isActive = activeSlide === i && slideNumber === questionNumber;

            let buttonStyle = {
                backgroundColor: hasAnswer ? 'rgb(250, 162, 66)' : '',
                color: isActive ? 'rgb(0, 63, 126)' : 'white',
            };

            if (isPassed) {
                if (rightObj?.[i]?.[item.number] === 1) {
                    buttonStyle = styles.right;
                } else if (rightObj?.[i]?.[item.number] === 0) {
                    buttonStyle = styles.wrong;
                } else {
                    buttonStyle = styles.halfOrChecking;
                }
            }

            return (
                <div
                    key={item.id}
                    className={isActive ? 'test-button-question-active' : 'test-button-question'}
                    style={ buttonStyle}
                    onClick={(e) => handlerOnClickQuestion(questionNumber, i, e)}
                >
                    {questionNumber}
                </div>
            );
        });


        return (
            <div
                key={task.id}
                className={'test-button-task'}
                style={{
                    backgroundColor: activeSlide === i ? 'rgb(99,175,253)' : 'transparent',
                    color: activeSlide === i ? 'rgb(0,63,126)' : 'white',
                }}
                onClick={()=>handlerOnClick(i)}
            >
                <span>{i + 1}</span>
                <div style={{display: 'flex', flexWrap: "wrap",alignItems: 'center'}}>{taskQuestions}</div>
            </div>
        );
    });

    return <div style={{display: 'flex', justifyContent: 'center', alignItems: "center", flexWrap: "wrap"}}>{blockTest}</div>
};

export default Panel;
